// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__cjE7q","icon":"Spinner_icon__HeDln","spin":"Spinner_spin__Fq4JT"};